var app = angular.module('stonehenge', ['mwl.calendar',
    'ngRoute',
    'ui.bootstrap',
    'ngAnimate',
    'angular-loading-bar',
    'angularUtils.directives.dirPagination',
    'chart.js',
    'bootstrapLightbox',
    'ngCookies',
    'nvd3', 'daterangepicker']);

function showLoginModal(modalProvider, $rootScope) {
    if (!$rootScope.ON_LOGIN) {
        $rootScope.ON_LOGIN = true;
        var modalInstance = modalProvider.open({
            controller: 'UserLoginController',
            templateUrl: 'src/user/html/user-login-modal.html',
            keyboard: false,
            backdrop: 'static'
        });
    }
}

function errorHandler(error) {
    console.log("Error:", error);
    let e = error.data
    if (e.status && e.message) {
        alert.error(e.message)
        throw new Error(e.message)
    } else {
        alert.error("Something went wrong =(")
        throw new Error("Internal server error")
    }
}

var alert = function () {
    return {
        success: function (message, title, options) {
            toastr.success(message, title || "Success", options)
        },
        warning: function (message, title, options) {
            toastr.warning(message, title || "Warning", options)
        },
        error: function (message, title, options) {
            toastr.error(message, title || "Error", options)
        },
        info: function (message, title, options) {
            toastr.info(message, title || "Info", options)
        },
        clearAll: function () {
            toastr.clear();
        }
    }
} ();

var Promise;

// listeners
app.run(['$rootScope', '$location', '$uibModal', '$uibModalStack', '$window', '$cookies', '$http', '$q',
    function ($rootScope, $location, $uibModal, $uibModalStack, $window, $cookies, $http, $q) {
        Promise = $q;

        $rootScope.$on('$locationChangeStart', function (event, next, current) {
            // checks token every change of url
            if (!$cookies.get('token')) {
                showLoginModal($uibModal, $rootScope);
                event.preventDefault();
            } else {
                $rootScope.token = $cookies.get('token');
            }
        })

        // fired when a response has 403 status
        $rootScope.$on('event:loginRequired', function (event, args) {
            alert.error(args.error);
            showLoginModal($uibModal, $rootScope);
        })

        $rootScope.$on('event:postSignOut', function () {
            delete $cookies.remove('token');
            alert.success("Signed out successfully");
            showLoginModal($uibModal, $rootScope);
        })
    }])

// routes
app.config(['$routeProvider', '$locationProvider', 'LightboxProvider', function ($routeProvider, $locationProvider, LightboxProvider) {
    LightboxProvider.templateUrl = '/assets/lightbox-template.html';

    $routeProvider
        // User
        .when('/users/', {
            controller: 'UserListController',
            templateUrl: 'src/user/html/user-list.html'
        })
        .when('/users/new', {
            controller: 'UserNewController',
            templateUrl: 'src/user/html/user-new.html'
        })
        .when('/users/:id', {
            controller: 'UserEditController',
            templateUrl: 'src/user/html/user-edit.html'
        })

        // Role
        .when('/roles/', {
            controller: 'RoleListController',
            templateUrl: 'src/role/html/role-list.html'
        })
        .when('/roles/new', {
            controller: 'RoleNewController',
            templateUrl: 'src/role/html/role-new.html'
        })
        .when('/roles/:id', {
            controller: 'RoleEditController',
            templateUrl: 'src/role/html/role-edit.html'
        })

        // Company
        .when('/companies/', {
            controller: 'CompanyListController',
            templateUrl: 'src/company/html/company-list.html'
        })
        .when('/companies/new', {
            controller: 'CompanyNewController',
            templateUrl: 'src/company/html/company-new.html'
        })
        .when('/companies/:id', {
            controller: 'CompanyEditController',
            templateUrl: 'src/company/html/company-edit.html'
        })

    // Pictures
    $routeProvider
        .when('/pictures/', {
            controller: 'PictureCalendarController',
            templateUrl: 'src/picture/html/picture-calendar.html'
        })
        .when('/pictures/list', {
            controller: 'PictureListController',
            templateUrl: 'src/picture/html/picture-list.html'
        })

    // Receivers
    $routeProvider
        .when('/receivers/', {
            controller: 'ReceiverListController',
            templateUrl: 'src/receiver/html/receiver-list.html'
        })

    // Forecast
    $routeProvider
        .when('/forecast/', {
            controller: 'ForecastListController',
            templateUrl: 'src/forecast/html/forecast-list.html',
            reloadOnSearch: false
        })
        .when('/forecast/:id', {
            controller: 'ForecastViewController',
            templateUrl: 'src/forecast/html/forecast-view.html'
        })

    // Feedback
    $routeProvider
        .when('/feedback/', {
            controller: 'FeedbackController',
            templateUrl: 'src/feedback/html/feedback.html'
        })
        // stock routes
        .when('/solenoid/', {
            controller: 'StockListController',
            templateUrl: 'src/stock/stock-list.html' 
        })
        .when('/solenoid/:id', {
            controller: 'StockDetailController',
            templateUrl: 'src/stock/stock-detail.html'
        })
        .when('/reviews/:id', {
            controller: 'ReviewController',
            templateUrl: 'src/review/review.html'
        })
        .when('/reviews', {
            controller: 'ReviewController',
            templateUrl: 'src/review/review.html'
        })


        .otherwise({ redirectTo: '/' });
}]);
